module.exports = __webpack_public_path__ + "static/media/a87dd701-7ef5-4f17-8eb3-e70582f25842.4621357e.JPG";